/* eslint-disable max-params */
// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable extra-rules/no-commented-out-code */
import getSaveForLaterItemsAPI from '@tcp/core/src/queries/getSaveForLaterItems.query.graphql';
import moveItemToBagAPI from '@tcp/core/src/queries/removeItemFromSFL.query.graphql';
import moveItemWithAccessoryToBagAPI from '@tcp/core/src/queries/removeBackpackItemFromSFL.query.graphql';
import updateItemInSFLAPI from '@tcp/core/src/queries/updateItemInSFL.query.graphql';
import addSaveForLaterItem from '@tcp/core/src/queries/addItemToSaveForLater.query.graphql';
import addBackpackItemToSFL from '@tcp/core/src/queries/addBackpackItemToSaveForLater.query.graphql';
import { checkIf0007Present } from '@tcp/core/src/components/common/molecules/Accessories/util/utility';
import { executeStatefulGraphQLQuery } from '../../handler';
import { isCanada as isCASite, getBrand } from '../../../utils';
import {
  responseContainsErrors,
  ServiceResponseError,
  getFormattedError,
} from '../../../utils/errorMessage.util';
import { flatCurrencyToCents, AVAILABILITY } from './CartItemTile';

/**
 * @function getTcpStyleQTYByLocation This function returns the appropriate multipack Badge qty based on the site (CA or US)
 * @param item {Object} The item to be worked on.
 * @return {String} multipack Badge qty
 */
export function getTcpStyleQTYByLocation(item) {
  return !isCASite()
    ? item.product && item.product.c_TCPProductIndUSStore
    : item.product && item.product.c_TCPProductIndCanadaStore;
}
/**
 * @function getTcpStyleTypeByLocation This function returns the appropriate multipack Badge type based on the site (CA or US)
 * @param item {Object} The item to be worked on.
 * @return {String} multipack Badge type
 */
export function getTcpStyleTypeByLocation(item) {
  return !isCASite()
    ? item?.product && item.product.c_TCPProductIndUSStore
    : item?.product && item.product.c_TCPProductIndCanadaStore;
}

const getFinalPDPUrl = (item) => {
  let pdpURL;
  if (getBrand()?.toUpperCase() === item?.product?.brand) {
    pdpURL = `us/p/${item?.product?.masterId}`;
  } else {
    pdpURL = `/p/${item?.product?.masterId}`;
  }
  return pdpURL;
};

export function getProductInfo(item, imageGenerator) {
  const { multipackCatentryId = null } = item;
  const returnProductInfo = {
    generalProductId: item.id,
    productPartNumber: item?.product?.masterId,
    skuId: item.id,
    name: item?.product?.name,
    imagePath: imageGenerator(item?.product?.masterId)
      ? imageGenerator(item?.product?.masterId)?.productImages[500]
      : '',
    pdpUrl: getFinalPDPUrl(item),
    color: {
      name: item.product.c_TCPColor,
      imagePath: imageGenerator(item?.product?.masterId)
        ? imageGenerator(item?.product?.masterId)?.productImages[500]
        : '',
    },
    // check before commit
    isGiftCard: item?.product?.c_isGiftCard, // To Do when consuming this data { color: 'Design', size: 'Value' }
    itemBrand: item?.product.brand,
    multiPackItems: multipackCatentryId,
    tcpStyleQty: getTcpStyleQTYByLocation(item),
    tcpStyleType: getTcpStyleTypeByLocation(item),
    Quantity: item.quantity,
    tcpStyleTypeOriginal: item?.c_TCPStyleType,
    seoToken: item.c_seoToken || item?.product?.pageKeywords,
  };
  returnProductInfo.size = item.product.c_size;
  returnProductInfo.fit = item.product.c_fit;
  returnProductInfo.upc = item.product.upc;
  return returnProductInfo;
}

export function deriveSflItemAvailability(item) {
  if (item.inventoryAvail > 0) {
    return AVAILABILITY.OK;
  }
  return AVAILABILITY.UNAVAILABLE;
}

export function getSflItemInventory(item) {
  return item.inventoryAvail;
}

export function getItemOfferPrice(item, sizeAndFit, isCanada) {
  const { isGiftCard } = item;
  let Price = '';
  if (isGiftCard && sizeAndFit) {
    Price = flatCurrencyToCents(sizeAndFit.TCPSize);
  } else {
    Price = isCanada
      ? flatCurrencyToCents(item.productInfo.offerPriceCAD)
      : flatCurrencyToCents(item.productInfo.offerPrice);
  }
  return Price;
}

export function formatSflItems(sflResponse = [], imageGenerator) {
  const sflObject = [];
  sflResponse.forEach((item) => {
    // const sizeAndFit = item.itemAtributes;
    sflObject.push({
      productInfo: getProductInfo(item, imageGenerator),
      itemInfo: {
        itemId: item?.id,
        offerPrice: item?.product?.price,
        listPrice: item?.product?.price,
        imagePath: imageGenerator(item?.product?.masterId)
          ? imageGenerator(item?.product?.masterId)?.productImages[500]
          : '',
        color: {
          name: item.product.c_TCPColor,
          imagePath: imageGenerator(item?.product?.masterId)
            ? imageGenerator(item?.product?.masterId)?.productImages[500]
            : '',
        },
        itemBrand: item?.product.brand,
        quantity: item.quantity,
        wasPrice: item?.c_list_price,
        lastViewedTime: item?.c_lastViewedTime,
        lastViewedPrice: item?.c_lastViewedPrice,
        itemUnitPrice: item?.product?.price,
      },
      skuInfo: {
        skuId: item.product.upc,
        upc: item.product.upc,
        imageUrl: imageGenerator(item?.product?.masterId)
          ? imageGenerator(item?.product?.masterId)?.productImages[500]
          : '',

        colorProductId: item.product.c_TCPColor,
        color: {
          name: item.product.c_TCPColor,
          imagePath: imageGenerator(item?.product?.masterId)
            ? imageGenerator(item?.product?.masterId)?.productImages[500]
            : '',
        },
        fit: item.product.c_fit,
        size: item.product.c_size,
        productId: item.product.id,
        variantId: item.product.id,
        unbxdProdId: item?.product?.masterId,
        quantity: item.quantity,
        prodPartNo: item?.product?.masterId,
        variantNo: item?.product?.manufacturerSku,
        TCPProductIndStore: !isCASite()
          ? item?.product.c_TCPProductIndUSStore
          : item?.product.c_TCPProductIndCanadaStore,
      },
      miscInfo: {
        // set badge info
        // badge: extractPrioritizedBadge(item.productInfo, getCartProductAttributes()),
        availability: item?.product.inventory?.ats !== 0 ? AVAILABILITY.OK : AVAILABILITY.SOLDOUT,
        c_accessories: item?.c_accessories,
        c_priceIncluded: item?.c_priceIncluded,
        c_mainProducts: item?.c_mainProducts,
        c_customizationType: item?.c_customizationType,
        TCPProductIndStore: !isCASite()
          ? item?.product.c_TCPProductIndUSStore
          : item?.product.c_TCPProductIndCanadaStore,
        clearanceItem: !isCASite()
          ? item?.product.c_TCPProductIndUSStore === 'Clearance'
          : item?.product.c_TCPProductIndCanadaStore === 'Clearance',
        isHardMarkEnabled: !isCASite()
          ? item?.product?.c_isHardMarkEnabledUS
          : item?.product?.c_isHardMarkEnabledCA,
        // sflAvailInventory: getSflItemInventory(item),
      },
      itemStatus: {},
    });
  });

  return sflObject;
}

/**
 * @function updateSflItem
 * @summary This API is used to remove an item from the sfl item list
 * @param {String} oldProductCatEntryId - CatEntryId of the sfl item that needs to be deleted
 * @param {String} newProductCatEntryId - CatEntryId of the sfl item that needs to be added
 * @param {Boolean} isRememberedUser - Is the user remembered
 * @param {Boolean} isRegistered - Is the user registered
 * @param {Object} imageGenerator - Image generator
 * @param {String} currencyCode - Currency code
 * @return Updated SFL items list
 */
export function updateSflItem(oldProductCatEntryId, newProductCatEntryId, sflId, imageGenerator) {
  return executeStatefulGraphQLQuery({
    query: updateItemInSFLAPI,
    variables: {
      itemId: oldProductCatEntryId,
      productId: newProductCatEntryId,
      sflListId: sflId,
    },
    fetchPolicy: 'no-cache',
    type: 'mutation',
  })
    .then((response) => {
      if (response.data.updateItemInSaveForLater.customerProductListItems) {
        return formatSflItems(
          response.data.updateItemInSaveForLater.customerProductListItems,
          imageGenerator
        );
      }
      return [];
    })
    .catch((err) => {
      throw getFormattedError(err);
    });
}

// eslint-disable-next-line max-params
// eslint-disable-next-line sonarjs/cognitive-complexity
export function addItemToSflList(
  catEntryId,
  isRememberedUser,
  isRegistered,
  imageGenerator,
  currencyCode,
  isCanada,
  sflId,
  orderItemsCartPage,
  orderAccessorieItems,
  wasPrice,
  price
) {
  const orderItems = orderItemsCartPage && JSON.parse(JSON.stringify(orderItemsCartPage));
  const orderAccessorieItemsParsed =
    orderAccessorieItems && JSON.parse(JSON.stringify(orderAccessorieItems));
  let itemId = '';
  let isThisBackPackCall = false;
  if (catEntryId && Array.isArray(catEntryId)) {
    itemId = catEntryId[0].catEntryId;
  } else {
    itemId = catEntryId;
  }
  const queryPayload = {
    productId: itemId,
    sflListId: sflId,
    c_list_price: wasPrice || price,
  };

  if (orderAccessorieItemsParsed && orderAccessorieItemsParsed[itemId]) {
    const is0007Present = checkIf0007Present(itemId, orderAccessorieItemsParsed);
    orderItems.forEach((item) => {
      // TODO if we have to check if only 0007 acc is present. Take payload from CartItemNewtile.
      if (
        item?.productInfo?.generalProductId === itemId &&
        ((item?.miscInfo?.c_accessories && item?.miscInfo?.c_accessories.length > 0) ||
          item?.miscInfo?.c_mainProducts ||
          is0007Present)
      ) {
        isThisBackPackCall = true;
      }
    });
  }
  return executeStatefulGraphQLQuery({
    query: isThisBackPackCall ? addBackpackItemToSFL : addSaveForLaterItem,
    variables: { request: queryPayload },
    type: 'mutation',
    fetchPolicy: 'no-cache',
  })
    .then((res) => {
      if (responseContainsErrors(res)) {
        throw new ServiceResponseError(res);
      } else {
        const data = isThisBackPackCall
          ? res?.data?.addBackpackItemToSaveForLater.customerProductListItems
          : res?.data?.addItemToSflList.customerProductListItems;
        const items = formatSflItems(data, imageGenerator);

        return { items, sflId: res?.data?.addItemToSflList?.id };
      }
    })
    .catch((err) => {
      throw getFormattedError(err);
    });
}

const isBackPackCallRequired = (miscInfo, productInfo, sflItems) => {
  const { accessories } = miscInfo;
  const parentAcc = JSON.parse(JSON.stringify(accessories));
  const sflItemsArr = JSON.parse(JSON.stringify(sflItems));

  let isBackPackCall = false;
  if (parentAcc && parentAcc.length) {
    for (let i = 0; i <= parentAcc.length; i += 1) {
      // eslint-disable-next-line no-loop-func
      sflItemsArr.map((item) => {
        if (
          (item?.productInfo?.upc === parentAcc[i] &&
            item?.productInfo?.tcpStyleTypeOriginal === '0007') ||
          item?.miscInfo?.c_accessories ||
          item?.miscInfo?.c_mainProducts
        ) {
          isBackPackCall = true;
        }
        return null;
      });
    }
  }
  return isBackPackCall;
};

export function moveItemToBagFromSFL(
  itemId,
  sflId,
  imageGenerator,
  miscInfo,
  productInfo,
  sflItems
) {
  // send product id in backpack call.
  // isThisBackPackCall will be true when there is any 0007 accessry present with parent product then we will run different flow,
  // else, everything will run as previously expected.

  const isThisBackPackCall = isBackPackCallRequired(miscInfo, productInfo, sflItems);
  const backPackPayload = {
    productId: productInfo?.upc,
    sflListId: sflId,
  };
  const nonBackPackPayload = {
    itemId,
    sflListId: sflId,
  };
  return executeStatefulGraphQLQuery({
    query: isThisBackPackCall ? moveItemWithAccessoryToBagAPI : moveItemToBagAPI,
    variables: isThisBackPackCall ? backPackPayload : nonBackPackPayload,
    fetchPolicy: 'no-cache',
    type: 'mutation',
  })
    .then((response) => {
      const productListItems = isThisBackPackCall
        ? response.data.removeBackpackItemFromSaveForLater.customerProductListItems
        : response.data.removeItemFromSaveForLater.customerProductListItems;
      if (productListItems) {
        return formatSflItems(productListItems, imageGenerator);
      }
      return [];
    })
    .catch((err) => {
      throw getFormattedError(err);
    });
}

export function getSflItems(sflId, imageGenerator) {
  return executeStatefulGraphQLQuery({
    query: getSaveForLaterItemsAPI,
    variables: {
      sflListId: sflId || '',
    },
    fetchPolicy: 'no-cache',
  })
    .then((response) => {
      let receivedSflId = '';
      let res = [];
      if (response.data.getSaveForLaterItems.customerProductListItems) {
        res = formatSflItems(
          response.data.getSaveForLaterItems.customerProductListItems,
          imageGenerator
        );
      }
      if (response.data.getSaveForLaterItems.id) {
        receivedSflId = response.data.getSaveForLaterItems.id;
      }
      return { res, receivedSflId };
    })
    .catch((err) => {
      throw getFormattedError(err);
    });
}

export default {
  formatSflItems,
  addItemToSflList,
  deriveSflItemAvailability,
  getSflItems,
  updateSflItem,
  getTcpStyleTypeByLocation,
  getTcpStyleQTYByLocation,
  moveItemToBagFromSFL,
};
